import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './lib/FontAwesomeIcons';
import { initRUM } from '@netlify/rum';
import config from '../config';
import { initLogging } from './modules/logging/loglevel';
import { initLogger } from './modules/logging/logger';
import { createAppStore } from './store/app';
import { setStore } from './modules/global.utils';
import App from './App';
import { ampli } from './ampli';
import segmentMiddleware from './modules/analytics/segmentMiddleware';
import loggerMiddleware from './modules/analytics/loggerMiddleware';

initRUM({
    applicationId: config.datadog.applicationId,
    clientToken: config.datadog.clientToken,
    service: config.datadog.service,
    version: process.env.VERSION_ID,
    env: config.env
});

const store = createAppStore();
setStore(store);

try {
    initLogging();
    initLogger({
        get projectId() {
            const state = store.getState();
            return state.studio.project?.id ?? (state.wizard.project?.id || undefined);
        }
    });
} catch (e) {
    console.log('Error init logging', e); // eslint-disable-line no-console
}

ampli.load({ environment: config.segment.analyticsEnv === 'prod' ? 'production' : 'development' });
ampli.addEventMiddleware(segmentMiddleware);

if (config.logging.logentries.logAnalyticsEvents) {
    ampli.addEventMiddleware(loggerMiddleware);
}

ampli.addEventMiddleware((payload, next) => {
    // This middleware short-circuits ampli by not calling next()
    // so that we don't call Amplitude's tracking api.
    // They assume we'll be using them as a destination for events, but we're not.
});

import(/* webpackChunkName: "debug" */ './modules/debug/index')
    .then((module) => {
        module.initDebugging();
    })
    .finally(() => {
        ReactDOM.createRoot(document.getElementById('app')!).render(
            <Provider store={store}>
                <App />
            </Provider>
        );
    });
